import { useState } from "react";
import { faqs } from "@/mocks/anime";

export default function FAQ() {
  const [open, setOpen] = useState<number>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="relative py-14 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-semibold px-4 py-1.5 mb-4">
            <i className="ri-questionnaire-line"></i>
            常见问题
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950">你可能想知道</h2>
          <p className="mt-3 text-foreground-700 text-sm md:text-base">
            关于缘分匹配、盲盒番剧与随缘漫游，这里都有答案。
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-2xl bg-background-50 border transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200/70"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900">{f.q}</span>
                  <span
                    className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-all ${
                      isOpen ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-100 text-foreground-700"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-96" : "max-h-0"
                  }`}
                >
                  <p className="px-5 md:px-6 pb-5 text-sm text-foreground-700 leading-relaxed">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}